import _ from 'lodash';
import getValue from './getValue';

export default ({ formattedValue, price, quantity, isDiscountPlan }) => {
  const discountValue = getValue(formattedValue);

  if (discountValue % 1 !== 0) return _.round(price * quantity * discountValue);

  return isDiscountPlan ? discountValue * quantity : discountValue;
};



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/getDiscountValue.js